import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MinusCircleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 11L7 13L17 13L17 11L7 11ZM12 2C6.48 2 2 6.48 2 12S6.48 22 12 22S22 17.52 22 12S17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12S7.59 4 12 4S20 7.59 20 12S16.41 20 12 20Z"
      fill="currentColor"
    />
  </svg>
);

MinusCircleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MinusCircleIcon);
